import React from 'react';
import { Card, Col, CardImg } from 'reactstrap';
import { subscribe } from 'react-contextual';
import ProgressiveImage from 'react-progressive-image';
import COLORS from '../../../../../common/colors';
import LocationIcon from '../../icons/locationIcon';
import { Tag } from '../../../elements';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

let referrer = '';

const NgoCard = (props) => {
	const {
		causes,
		locations,
		name,
		profile,
		heroImage,
		heroImageDesktop,
		heroImageMobile,
		otpLink,
		reliabilityRating,
		contactDetails,
		logo,
		slug,
	} = props.ngoResult;
	const {
		type, position, newTab, size,
	} = props;
	const image = heroImageMobile || '/static/images/nonprofit/hero/ashadeep_mobile.jpg'
	const findthumbnail = (image) => {
		 // image = '/static/images/nonprofit/hero/ashadeep_mobile.jpg'
		const pathList = image.split('/');
		let path = '';
		for (let i = 0; i < pathList.length - 1; i++) { path += `${pathList[i]}/`; }
		path += `thumbnail/${pathList[pathList.length - 1]}`;
		return path;
	};

	const findReferrerHash = () => {
		return (window && window.location.href.indexOf('volunteering') > -1 ) ?   'volunteering' : '';
	}
	referrer = findReferrerHash();

	if (Object.keys(props.ngo).length === 0 && props.ngo.constructor === Object) {
		return null;
	}
	return (
		<Col className={props.className}>
			<Card>
				<a
					rel="noopener noreferrer"
					className="no-hover-a"
					style={{ cursor: 'pointer' }}
					href={`/nonprofit/${slug}`}
					target={newTab ? '_blank' : '_self'}
					onClick={() => {
						const eventInfo = {
							position: position + 1,
							productName: name,
							productId: null,
							url: window.location.toString(),
						};
						if (window.eventDispatcher) {
							window.eventDispatcher.dispatchEventSync('ngoClick', eventInfo, {amplitude: true});
						}
						return true;
					}
					}
				>
					<div style={{ position: 'relative' }}>
						<ProgressiveImage src={`${config.cdnUrl}${findthumbnail(image)}`} placeholder={`${config.cdnUrl}${image}`}>
							{(src, loading) => (
								<CardImg top width="100%" style={{ opacity: loading ? 1 : 1 }} src={src} />
							)}
						</ProgressiveImage>
						<TagRow tags={[]} />
					</div>
					<div className="card-body">
						<div className="card-tags row">
							<div className="col-6 col-lg-6 col-md-12 col-sm-6 p-0">
								<span className="small-text primary-color float-left" style={{ textTransform: 'capitalize' }}>
									{typeof causes !== 'undefined' ? causes[0] : ''}
								</span>
							</div>
							<div className="col-6 col-lg-6 col-md-12 col-sm-6 p-0">
								<span className="small-text mid-grey float-right" style={{ textTransform: 'capitalize' }}>
									<LocationIcon
										color={COLORS.givePrimary}
										size="0.875rem"
										style={{
											display: 'inline-block', lineHeight: '0', marginRight: '3px', width: '0.875rem',
										}}
									/>
									{typeof locations !== 'undefined' ? locations[0] : ''}
								</span>
							</div>
						</div>
						<h5 className="card-title text-clamp-3" style={{ lineHeight: '1.375rem' }}>
							{/* <Link prefetch href={programLink}>} */}
							<span className="darker-grey">
								{name}
							</span>
							<span className="sh w-100">
									&nbsp;by&nbsp;{name}
							</span>
						</h5>
					</div>
				</a>
			</Card>
			<style jsx global>{`
				.card-price {
					margin-bottom: 10px;
				}
				.card-price h6 {
					margin-bottom: 0;
				}
				.tag-row {
					margin-bottom: 10px;
				}
				.giveassured-position {
					position: absolute;
					bottom: 3px;
					right: 3px;
					background: white;
					padding: 1px 5px;
					border-radius: 5px;
					box-shadow: 0 2px 2px rgba(50,50,93,0), 0 1px 2px rgba(0,0,0,0.08);
				}
			`}
			</style>
		</Col>
	);
};

const TagRow = ({ tags }) => (
	typeof tags !== 'undefined' ?
		<div className="justify-content-end align-self-start tag-row-position d-flex">
			{tags.map(tag => <Tag {...tag} design="capsule" />)}
		</div>
		:
		null
);

// NgoCard.propTypes = {
// 	ngo: PropTypes.shape({
// 		cause: PropTypes.string.isRequired,
// 		location: PropTypes.string.isRequired,
// 		title: PropTypes.string.isRequired,
// 		ngo: PropTypes.string.isRequired,
// 		price: PropTypes.number.isRequired,
// 		image: PropTypes.string.isRequired,
// 		programLink: PropTypes.string.isRequired,
// 	}).isRequired,
// 	size: PropTypes.shape({}),
// };

NgoCard.defaultProps = {
	size: { lg: '4', sm: '6', xs: '12' },
	className: 'd-flex program-card-11 stack-3',
};

export default subscribe()(NgoCard);
